
import { AskedFilter } from "@/utils/report-engine-settings/asked-filter";
import Vue from "vue";
import { getModel, Model } from "@/utils/models/model";
import AppCustomFilterSelector from "@/components/models/CustomFilterSelector.vue";
import AppHumanFilterEditValue from "@/components/models/HumanFilterEditValue.vue";
import { IModelProperty } from "@/utils/models/model-field";
import { IReportEngineSettingsWrapper } from "@/utils/report-engine-settings/report-engine-settings-wrapper";
import { IModel } from "@/utils/models/model-interface";
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services";

export default Vue.extend({
	props: {
		filter: {
			type: Object as ()=>AskedFilter,
			required: true
		},
		settings: {
			type: Object as ()=>IReportEngineSettingsWrapper,
			required: true
		},
		model: {
			type: Object as ()=>IModel,
			required: true
		}
	},
	computed: {
		isNamedFilter():boolean {
			return this.filter.FieldType.startsWith("named-filter/");
		},
		isVariableLengthFilter():boolean{
			return this.filter.Operator == "in" || this.filter.Operator == "not in";
		},
		namedFilterModel():Model | null{
			if (!this.isNamedFilter){
				return null;
			}
			return getModel(this.filter.FieldType.split("/")[1]);
		},
		field():IModelProperty | null {
			if (!this.model) {
				return null;
			}
			let field = this.model.getFilterField(this.filter.Field);
			if (!field) {
				return null;
			}
			return field.field;
		},
		browse():Browse | null {
			if (this.settings.Settings.isSourceTypeBrowse()) {
				return BrowseService.getBrowseWithoutViewSettings(this.settings.Settings.getBrowseIDFromDataSource());
			}
			return null;
		},
		fieldType():string {
			if (!this.model) {
				return "string";
			}
			return this.filter.getFilterValueType(this.model, this.browse);
		}
	},
	components: {
		AppCustomFilterSelector,
		AppHumanFilterEditValue
	},
	i18nEx: {
		componentPrefix: "components.reportengine"
	}
});
